export const SETypen = {
  Gewaesser: 1,
  Transportelement: 2,
  Bauwerk: 3,
  NatuerlichesTG: 4,
  KanalisierteFlaeche: 5
}

export const layer = {
  bauwerke: 1,
  transportelemente: 2,
  gewaesser: 3,
  teilgebiete: 4,
  kanalFlaechen: 5,
}

export default  {
  SETypen,
  layer
}